package twist.mena.sports.admin.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.theme.*

data class Column<T>(
    val header: String,
    val render: @Composable (T) -> Unit
)

@Composable
fun <T> DataTable(
    columns: List<Column<T>>,
    rows: List<T>,
    total: Int = rows.size,
    offset: Int = 0,
    limit: Int = 50,
    onPageChange: ((Int) -> Unit)? = null
) {
    val colors = AppTheme.colors

    Div({
        style {
            cardStyle(colors)
            padding(0.px)
            overflow("hidden")
        }
    }) {
        Table({
            style {
                width(100.percent)
                property("border-collapse", "collapse")
            }
        }) {
            Thead {
                Tr {
                    columns.forEach { col ->
                        Th({
                            style { tableHeaderStyle(colors) }
                        }) { Text(col.header) }
                    }
                }
            }
            Tbody {
                if (rows.isEmpty()) {
                    Tr {
                        Td({
                            attr("colspan", columns.size.toString())
                            style {
                                padding(40.px)
                                textAlign("center")
                                color(Color(colors.textMuted))
                            }
                        }) { Text("No data") }
                    }
                } else {
                    rows.forEach { row ->
                        Tr({
                            style {
                                property("border-bottom", "1px solid ${colors.border}")
                            }
                        }) {
                            columns.forEach { col ->
                                Td({
                                    style {
                                        padding(Spacing.md)
                                        fontSize(Typography.base)
                                        textAlign("left")
                                        color(Color(colors.text))
                                    }
                                }) {
                                    col.render(row)
                                }
                            }
                        }
                    }
                }
            }
        }

        // Pagination
        if (onPageChange != null && total > limit) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    padding(Spacing.md, Spacing.lg)
                    property("border-top", "1px solid ${colors.border}")
                    fontSize(Typography.sm)
                    color(Color(colors.textMuted))
                }
            }) {
                Span { Text("Showing ${offset + 1}-${minOf(offset + limit, total)} of $total") }
                Div({
                    style { display(DisplayStyle.Flex); gap(Spacing.sm) }
                }) {
                    if (offset > 0) {
                        Button({
                            onClick { onPageChange(offset - limit) }
                            style { paginationButtonStyle(colors, disabled = false) }
                        }) { Text("Previous") }
                    }
                    if (offset + limit < total) {
                        Button({
                            onClick { onPageChange(offset + limit) }
                            style { paginationButtonStyle(colors, disabled = false) }
                        }) { Text("Next") }
                    }
                }
            }
        }
    }
}
